import { cn } from '@/common/utilities.ts'
import { useTranslation } from 'react-i18next'

type ProgressBarProps = {
  value: number
  barCN?: string
}
export default function ProgressBar({ value, barCN }: ProgressBarProps) {
  const { t: translate } = useTranslation()
  if (value < 0) value = 0
  if (value > 100) value = 100
  return (
    <>
      <h4 className="sr-only">{translate('progress_bar')}</h4>
      <div
        aria-hidden="true"
        className="overflow-hidden rounded-full bg-gray-200"
      >
        <div
          style={{ width: `${value}%` }}
          className={cn('h-2 rounded-full bg-primary', barCN)}
        />
      </div>
    </>
  )
}
